import React, { useState, useEffect, useRef } from "react";
import AccordionButton from "./AccordionButton";
import AccordionItem from "./AccordionItem";
import AccordionContext from "./AccordionContext";
import AccordionBody from "./AccordionBody";

function Accordion({ className, children, defaultActiveKey, onChange }) {
    const didMountRef = useRef(false);
    const [activeItem, setActiveItem] = useState(defaultActiveKey);

    useEffect(() => {
        if (didMountRef.current && typeof onChange === "function") {
            onChange({ eventKey: activeItem });
        }
        didMountRef.current = true;
    }, [activeItem, onChange]);

    return (
        <AccordionContext.Provider value={{ activeItem, setActiveItem }}>
            <div className={className}>{children}</div>
        </AccordionContext.Provider>
    );
}

export default Object.assign(Accordion, {
    Body: AccordionBody,
    Button: AccordionButton,
    Item: AccordionItem
});
